import { AsyncReturnType } from "type-fest";

import { TypeaheadService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof TypeaheadService.createOccupation>[0];
type Data = AsyncReturnType<typeof TypeaheadService.createOccupation>;
type Error = unknown;

export const useCreateOccupation = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    TypeaheadService.createOccupation,
    options
  );

  return result;
};
